import { useStaticQuery, graphql } from 'gatsby'

export const usePostExcerpt = title => {
  const { event, blog,video } = useStaticQuery(excerptQuery)
  const list = [...event.nodes, ...blog.nodes,...video.nodes]
  const item = list.filter(item => item.title === title)
  return item.length > 0 ? item[0].excerpt : ''
}

const excerptQuery = graphql`
  query {
    event: allStrapiEvent {
      nodes {
        title
        excerpt {
          data {
            excerpt
          }
        }
      }
    }
    blog: allStrapiBlog {
      nodes {
        title
        excerpt {
          data {
            excerpt
          }
        }
      }
    }
    video: allStrapiVideo {
      nodes {
        title
        excerpt {
          data {
            excerpt
          }
        }
      }
    }
  }
`
